module.exports = __webpack_public_path__ + "r-v3/img/coachmark_arrow_blue_08.2d72d2e3.svg";